export default "__VITE_ASSET__DkQOjgkw__"